import { render, staticRenderFns } from "./oldPrivacy.vue?vue&type=template&id=a862557e&scoped=true&"
import script from "./oldPrivacy.vue?vue&type=script&lang=js&"
export * from "./oldPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./oldPrivacy.vue?vue&type=style&index=0&id=a862557e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a862557e",
  null
  
)

export default component.exports